import { useState } from "react";
import logo from "../assets/logo.png";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../apiConfig";
import successCampaign from "../assets/after-apply-campaign.gif";
import alreadyApplied from "../assets/already_applied.gif";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";

const Header = ({ campaignName }) => {
  const [isApplied, setIsApplied] = useState(false);
  const [message, setMessage] = useState("");

  let successText = `
  <h5 style="text-align:center">You’ve successfully applied to <b>Amorefy</b>!</h5>
  <p style="text-align:center; margin-top:8px">
    Thank you for showing interest in this campaign. Our team will carefully review your profile and reach out to you shortly with the next steps.
    <br />
    Keep an eye on your email for updates!
  </p>`;

  const [open, setOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const influencerId = searchParams.get("influencerId");
  const params = useParams();
  const { id } = params;

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const applyCampaignHandler = async () => {
    try {
      const res = await axios.post(`${baseUrl}/applyByInvitation`, {
        influencerId,
        campaignId: id,
      });

      if (res?.data?.message === "Application recorded") {
        setMessage(successText);
        setIsApplied(true);
      } else {
        setMessage(res?.data?.message);
        setIsApplied(true);
      }
    } catch (error) {
      console.log(error);
      const errorMsg = error?.response?.data?.message || "Something went wrong";
      setMessage(errorMsg);
      setIsApplied(true);
    }
  };

  return (
    <AppBar
      position="fixed"
      elevation={1}
      sx={{ backgroundColor: "#fff", boxShadow: "none" }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box component="a" href="https://www.solebs.com" target="_blank">
          <Box
            component="img"
            src={logo}
            alt="solebs logo"
            sx={{ height: 40 }}
          />
        </Box>

        <Button variant="contained" color="primary" onClick={handleOpen}>
          Apply Now
        </Button>
      </Toolbar>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        {!isApplied && <DialogTitle>Apply to This Campaign</DialogTitle>}
        <DialogContent dividers>
          {isApplied ? (
            <Box textAlign="center">
              <Box
                component="img"
                src={
                  message === "Already applied to this campaign!"
                    ? alreadyApplied
                    : successCampaign
                }
                alt="campaign status"
                sx={{ width: 200, mb: 2 }}
              />
              <div dangerouslySetInnerHTML={{ __html: message }} />
            </Box>
          ) : (
            <Typography>
              You're about to apply to{" "}
              <b style={{ textTransform: "capitalize" }}>{campaignName}</b>.
              Please make sure you've read all the campaign details and meet the
              requirements. Once applied, our team will review your profile.
            </Typography>
          )}
        </DialogContent>
        {!isApplied && (
          <DialogActions>
            <Button onClick={handleClose} color="inherit">
              Cancel
            </Button>
            <Button
              onClick={applyCampaignHandler}
              variant="contained"
              disabled={isApplied}
            >
              Yes, Apply
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </AppBar>
  );
};

export default Header;
